import { useCallback, useContext, useEffect, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { AuthContext } from "../../../../contexts/AuthContext";
import {
  chuyen_giao_chuyen_nhuong_don_van_bang,
  dang_ky_ban_quyen,
  dang_ky_gia_han,
  dang_ky_kieu_dang_cong_nghiep,
  dang_ky_nhan_hieu,
  dang_ky_sang_che_giai_phap_huu_ich,
  dang_ky_sua_doi_don_van_bang,
  dich_vu_khac,
  tra_cuu_thong_tin,
} from "../../quan-ly-khach-hang/components/data/form_data";
import { toast } from "react-toastify";
import Loading from "../../components/Loading";
import DynamicForm from "../../components/DynamicForm";
import { customerProfileService } from "../../../../services/api/customerProfileService";
import { mapFormData } from "../../../../utils/MappingFormData";

const EditProfile = () => {
  const [loading, setLoading] = useState(false);
  const { id } = useParams();
  const location = useLocation();
  const { token } = useContext(AuthContext);
  const [formData, setFormData] = useState([]);
  const [data, setData] = useState({});
  const [info, setInfo] = useState([]);
  const [represent, setRepresent] = useState({});
  const [brand, setBrand] = useState("");
  const [category, setCategory] = useState("");
  const [serviceName, setServiceName] = useState("");

  const formatData = (response) => {
    const profile = response.profile || {};
    const serviceId = profile.serviceId || {};
    return {
      formName: serviceId.formName || "",
      profile_name: serviceId.serviceName || "",
      profile_image: profile.image?.url || "",
      isLookup: profile.isLookup,
      isRequire: profile.isRequire,
      isOriginal: profile.isOriginal || false,
      contentRequire: profile.contentRequire,
    };
  };

  const fetchFormName = useCallback(async (formName) => {
    try {
      setLoading(true);
      switch (formName) {
        case "dang-ky-nhan-hieu":
          setFormData(dang_ky_nhan_hieu);
          break;
        case "dang-ky-kieu-dang-cong-nghiep":
          setFormData(dang_ky_kieu_dang_cong_nghiep);
          break;
        case "dang-ky-sang-che-giai-phap-huu-ich":
          setFormData(dang_ky_sang_che_giai_phap_huu_ich);
          break;
        case "dang-ky-gia-han":
          setFormData(dang_ky_gia_han);
          break;
        case "dang-ky-sua-doi-don-van-bang":
          setFormData(dang_ky_sua_doi_don_van_bang);
          break;
        case "chuyen-giao-chuyen-nhuong-don-van-bang":
          setFormData(chuyen_giao_chuyen_nhuong_don_van_bang);
          break;
        case "tra-cuu-thong-tin":
          setFormData(tra_cuu_thong_tin);
          break;
        case "dang-ky-ban-quyen":
          setFormData(dang_ky_ban_quyen);
          break;
        case "dich-vu-khac":
          setFormData(dich_vu_khac);
          break;
        default:
          toast.error("Không tồn tại form có tên như trên!!");
      }
    } catch (error) {
      toast.dismiss();
      toast.error("Lỗi khi lấy dịch vụ từ server");
      console.error("Fetch service error:", error);
    } finally {
      setLoading(false);
    }
  }, []);

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await customerProfileService.get_detail(id, token);
      fetchFormName(response.data.profile?.serviceId?.formName);
      setData(formatData(response.data));
      setRepresent(response.data.profile?.represent ?? null);
      setBrand(response.data.profile?.brand);
      setInfo(response.data.profile.info);
      setCategory(response.data.profile.serviceId.category.categoryName);
      setServiceName(response.data?.profile?.serviceId?.serviceName || "");
    } catch (error) {
      toast.dismiss();
      toast.error(
        error.response
          ? `${error.response?.data?.message}`
          : "Không thể kết nối tới server. Vui lòng kiểm tra mạng."
      );
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  }, [id, token, fetchFormName]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  useEffect(() => {
    setData((prevData) => {
      if (!info || info.length === 0) {
        console.warn("INFO rỗng, giữ nguyên data cũ");
        return prevData;
      }
      if (!formData || formData.length === 0) {
        console.warn(" FORM DATA rỗng, giữ nguyên data cũ");
        return prevData;
      }
      const newInfo = mapFormData(info, formData);
      return {
        ...prevData,
        info: newInfo,
      };
    });
  }, [info, formData]);

  if (loading || !data.info) {
    return (
      <div className="flex h-full items-center justify-center">
        <Loading />
      </div>
    );
  }

  return (
    <DynamicForm
      formData={formData}
      initData={data.info}
      data={data}
      id={id}
      token={token}
      isEdit={true}
      representData={represent || undefined}
      branData={brand}
      category={category}
      serviceName={serviceName}
      navigationState={location.state}
      navigationSearch={location.search}
    />
  );
};

export default EditProfile;
